import { MeterColumn } from '@contracts';

export const DEFAULT_WATER_METER_COLUMNS: MeterColumn[] = [
  {
    key: 'no',
    label: 'meter_list.no',
    type: 'text',
    sortable: false,
    visible: true,
    exportable: true,
    valueGetter: (_row, index, pageIndex, pageSize) =>
      pageIndex * pageSize + index + 1,
  },
  {
    key: 'module',
    label: 'Module',
    field: 'module',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'name',
    label: 'meter_list.name',
    field: 'name',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'type',
    label: 'meter_list.type',
    field: 'type',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'last_active_at',
    label: 'Last Active',
    field: 'last_active_at',
    type: 'datetime',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'status',
    label: 'meter_list.status',
    field: 'status',
    type: 'status',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'volume',
    label: 'Volume',
    field: 'volume',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'conv_ip',
    label: 'meter_list.conv_ip',
    field: 'conv_ip',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'port',
    label: 'meter_list.port',
    field: 'port',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'meter_id',
    label: 'meter_list.meter_id',
    field: 'meter_id',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'loop_name',
    label: 'Loop Name',
    field: 'loop_name',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'brand_name',
    label: 'Brand Name',
    field: 'brand_name',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'tags',
    label: 'Tags',
    field: 'tags',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'tenant_name',
    label: 'meter_list.tenant_name',
    field: 'tenant_name',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'detail',
    label: 'meter_list.detail',
    type: 'link',
    sortable: false,
    visible: true,
    exportable: false,
  },
];
